import { Orientation } from "appworks/graphics/canvas/orientation";
import { GraphicsService } from "appworks/graphics/graphics-service";
import { Layers } from "appworks/graphics/layers/layers";
import { ParticleService } from "appworks/graphics/particles/particle-service";
import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { ParticleContainer } from "appworks/graphics/pixi/particle-container";
import { Position } from "appworks/graphics/pixi/position";
import { Services } from "appworks/services/services";
import { AngleBetween } from "appworks/utils/math/angle";
import { RandomRangeInt } from "appworks/utils/math/random";
import { Timer } from "appworks/utils/timer";
import { Tween } from "appworks/utils/tween";

export class BigWinFirework {
    protected layer: Layers;

    constructor() {
        this.launchFirework();
    }

    protected launchFirework(): void {

        this.layer = Layers.get("BigWinFirework");
        const target = this.getRandomPositionFromRectangle("firework_target");
        const source = this.getRandomPositionFromRectangle("firework_source");

        [Orientation.LANDSCAPE, Orientation.PORTRAIT].forEach((orientation) => {
            const firework = Services.get(GraphicsService).createSprite("HardRain");
            const inactiveOrientation = orientation === Orientation.LANDSCAPE ? Orientation.PORTRAIT : Orientation.LANDSCAPE;

            firework[inactiveOrientation] = Position.unavailable();
            firework[orientation].y = source[orientation].y;
            firework[orientation].x = source[orientation].x;
            firework.rotation = AngleBetween(firework[orientation], target[orientation]);
            firework.scale.set(4, 4);
            const tween = new Tween(firework[orientation]);

            tween.to(target[orientation], 200);

            tween.onComplete(() => {
                this.explodeFirework(target, orientation, inactiveOrientation);
                this.layer.remove(firework);
                firework.destroy();
            });

            this.layer.add(firework);

            tween.start();
            return tween;
        });
    }

    protected getRandomPositionFromRectangle(positionName: string) {
        const possibleRange = this.layer.getPosition(positionName);

        const positions = [Orientation.LANDSCAPE, Orientation.PORTRAIT].map((orientation) => {
            const x = RandomRangeInt(possibleRange[orientation].x, possibleRange[orientation].x + possibleRange[orientation].width);
            const y = RandomRangeInt(possibleRange[orientation].y, possibleRange[orientation].y + possibleRange[orientation].height);
            return new Position(x, y);
        });

        return new DualPosition(positions[0], positions[1]);
    }

    protected explodeFirework(target: DualPosition, orientation: Orientation, inactiveOrientation: Orientation): void {

        const burstContainer = new ParticleContainer();
        burstContainer.dualPosition[inactiveOrientation] = Position.unavailable();
        const sparkContainer = new ParticleContainer();
        sparkContainer.dualPosition[inactiveOrientation] = Position.unavailable();

        const burst = Services.get(ParticleService).add("bigWinFireworkBurst", burstContainer);
        const spark = Services.get(ParticleService).add("bigWinFireworkSpark", sparkContainer);

        this.layer.add(burstContainer, false, true, "bigWinFireworkBurst");
        this.layer.add(sparkContainer, false, true, "bigWinFireworkSpark");

        Services.get(ParticleService).get(burst.id).spawnPos.x = Services.get(ParticleService).get(spark.id).spawnPos.x = target[orientation].x;
        Services.get(ParticleService).get(burst.id).spawnPos.y = Services.get(ParticleService).get(spark.id).spawnPos.y = target[orientation].y;

        Timer.setTimeout(() => {
            Services.get(ParticleService).remove(burst);
            Services.get(ParticleService).remove(spark);
        }, 3000);
    }
}
